export default __webpack_public_path__ + "static/media/uncheck-white-icon.7bbcb2da.svg";